// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"PowerAnytime_TheComp__j4l__"};